import { render, staticRenderFns } from "./GatewayFirmware.vue?vue&type=template&id=65377865&"
import script from "./GatewayFirmware.vue?vue&type=script&lang=js&"
export * from "./GatewayFirmware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65377865')) {
      api.createRecord('65377865', component.options)
    } else {
      api.reload('65377865', component.options)
    }
    module.hot.accept("./GatewayFirmware.vue?vue&type=template&id=65377865&", function () {
      api.rerender('65377865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Firmware/GatewayFirmware.vue"
export default component.exports